import { api, CsrfHeaderAndCookieName, getCsrfTokenValue } from './httpClient';

async function getConfig() {
    const endPoint = `${this.baseUrl}/product/config`;
    const config = {
        headers: {
            [CsrfHeaderAndCookieName]: getCsrfTokenValue()
        },
    };
    return (await api.get(endPoint, config)).data;
};

async function startTransaction() {
    const endPoint = `${this.baseUrl}/startTransaction`;
    const config = {
        headers: {
            [CsrfHeaderAndCookieName]: getCsrfTokenValue()
        },
    };
    return (await api.get(endPoint, config)).data;
};

async function checkEligibility(correlationId, payload) {
    console.log('performing eligibility check!!');
    if (this.appConfig.baseUrl === 'MOCK') {
        return this.appConfig.mocks.checkEligibility;
    }
    const endPoint = `${this.baseUrl}/eligibility/check`;
    const config = {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'correlationId': correlationId,
            [CsrfHeaderAndCookieName]: getCsrfTokenValue()
        },
    };
    return (await api.post(endPoint, payload ?? {}, config)).data;
}

async function submitApplication(payload) {
    const endPoint = `${this.baseUrl}/apply`;

    const config = {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'correlationId': payload.correlationId,
            'x-sync-submission': this?.appConfig?.applyWaitsForSubmissionWorkflow ?? true,
            [CsrfHeaderAndCookieName]: getCsrfTokenValue()
        },
    };
    return (await api.post(endPoint, payload, config)).data;
};

export const gaasApiServiceClientFactory = applicationConfigurationConstants => {
    function gaasApiClient() {

        this.appConfig = applicationConfigurationConstants;
        // eslint-disable-next-line max-len
        this.baseUrl = `${applicationConfigurationConstants.baseUrl}/api/gaas/v2/${applicationConfigurationConstants.productCode}`;
        this.getConfig = () => getConfig.call(this);
        this.startTransaction = () => startTransaction.call(this);
        this.checkEligibility = (correlationId, payload) => checkEligibility.call(this, correlationId, payload);
        this.submitApplication = payload => submitApplication.call(this, payload);
    };
    return new gaasApiClient();
};

export default {
    gaasApiServiceClientFactory: gaasApiServiceClientFactory
};
